import { ChakraProvider } from '@chakra-ui/react';
import { UnsupportedBrowser, enrolyTheme, FetchErrorBoundary, toastOptions } from 'shared-components';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorBoundary } from './ErrorBoundary';
import errorService from './services/errorService';
import { getGlobalConfig } from './utilities/globalConfig';
import { ContextWrapper } from './ContextWrapper';
import { Authentication } from 'shared-components/authentication';
import ToastContainer from './ToastContainer';

export const studentBaseUrl = '/student';

function App() {
  const globalConfig = getGlobalConfig();
  const location = useLocation();
  const { pathname } = location;

  // Clear accumulated fetch errors when the user navigates to a different route.
  // Without this, an API error on one record would persist across all subsequent records.
  useEffect(() => {
    errorService.reset();
  }, [pathname]);

  return (
    <FetchErrorBoundary errorService={errorService}>
      <ErrorBoundary resetKey={pathname}>
        <ChakraProvider theme={enrolyTheme} toastOptions={toastOptions}>
          <UnsupportedBrowser>
            <Authentication
              assetsUrl={globalConfig.assetsUrl}
              appClient={globalConfig.staffAppClient}
              userPoolId={globalConfig.userpool}
              mfaEnabledInConfig={globalConfig.staffMFAEnabled}
              uniCode={globalConfig.uni}
              samlEnabled={globalConfig.samlEnabled}
              apiUrl={globalConfig.apiUrl}
              cognitoDomain={globalConfig.cognitoDomain}
              cognitoProviderName={globalConfig.cognitoProviderName}
              redirectUrl={globalConfig.redirectUrl}
              cognitoEndpoint={globalConfig.cognitoEndpoint || import.meta.env.VITE_COGNITO_ENDPOINT}
            >
              <>
                <ContextWrapper />
                <ToastContainer />
              </>
            </Authentication>
          </UnsupportedBrowser>
        </ChakraProvider>
      </ErrorBoundary>
    </FetchErrorBoundary>
  );
}

export { App };
